import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { SIGNUP_WIZARD_STEPS } from "user/model"
import { SignUpWizardAgencyForm } from "./SignUpWizardAgencyForm"
import { SignUpWizardUserForm } from "./SignUpWizardUserForm"
import { SignUpWizardVerification } from "./SignUpWizardVerification"

interface ISignUpWizardContentProps {
  activeStep: SIGNUP_WIZARD_STEPS
}

const SignUpWizardContentFn = React.memo(({ activeStep }: ISignUpWizardContentProps) => {
  return (
    <FlexBox vertical fullWidth jc="start" sx={{ height: "calc(100% - 6.5rem)", pt: "1rem" }}>
      {activeStep === SIGNUP_WIZARD_STEPS.FIRST ? (
        <SignUpWizardUserForm />
      ) : activeStep === SIGNUP_WIZARD_STEPS.SECOND ? (
        <SignUpWizardAgencyForm />
      ) : (
        <SignUpWizardVerification />
      )}
    </FlexBox>
  )
})

export const SignUpWizardContent = connect(
  (state: IRootState): ISignUpWizardContentProps => ({
    activeStep: state.user.signup.step
  })
)(SignUpWizardContentFn)
